import { useQuery } from "@tanstack/react-query";
import { requestSeries, getDevMode } from "../api/aquastrong";

export const usePumpSeries = () => {
  const devSuffix = getDevMode() ? "-dev" : "";
  return useQuery({
    queryKey: ["pumpSeries" + devSuffix],
    queryFn: async () => {
      const data = await requestSeries();
      if (data?.error) {
        throw new Error(data.message || "Ошибка загрузки данных");
      }
      return data;
    },
  });
};